/**
 * Famly is where enquiries and application forms are handled, so every
 * "enquire about a place" call to action across the site points here.
 *
 * The query string sits after the `#`, which makes it part of the URL fragment.
 * Always pass this constant through verbatim — running it through a URL builder
 * or a param helper drops `institutionId`/`hmac` and the link stops working.
 */
export const FAMLY_INQUIRY_URL =
  'https://app.famly.co/#/inquiry?institutionId=194ecf49-ddf4-4cb4-9522-452c9ba2dc64&hmac=11d7e4c7d0ba1527e64789ce3768dd692b914cec98591641e269298fd5f34e1d&locale=en_GB';
